<template>
  <div>
    <!-- 🔙 Back Button -->
    <v-container class="mb-3 flex">
      <v-spacer />
      <v-btn class="btn btn-secondary" @click="goBack">
        ← Back to Consumers
      </v-btn>
    </v-container>

    <!-- Loading -->
    <div v-if="consumer.loading" class="text-center my-4">
      Loading consumer...
    </div>

    <!-- Content -->
    <v-container v-else>
      <div v-if="consumer.data" class="text-h5 font-weight-bold mb-3 text-center">
        {{ consumer.data.name }}
      </div>

      <v-row justify="center" class="mt-6">
        <v-col cols="12" sm="6" md="4">
          <v-card
            outlined
            height="200"
            class="sales-choice-card d-flex flex-column align-center justify-center"
            @click="goToCashSales"
          >
            <v-icon size="64" color="teal">
              mdi-cash-register
            </v-icon>
            <div class="text-h6 mt-2">
              Cash Sales
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card
            outlined
            height="200"
            class="sales-choice-card d-flex flex-column align-center justify-center"
            @click="goToCreditSales"
          >
            <v-icon size="64" color="green">
              mdi-clipboard-multiple
            </v-icon>
            <div class="text-h6 mt-2">
              Credit Sales
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { authAxios } from '@/extra-functions/axios.extra'
import { ErrorPopup } from '@/lib/utils'
import { AxiosError } from 'axios'

export default {
  name: 'ConsumerSalesChooser',
  data() {
    return {
      consumer: {
        data: null,
        loading: false,
        controller: null,
      },
    }
  },
  created() {
    this.fetchConsumer()
  },
  unmounted() {
    this.consumer.controller?.abort()
  },
  methods: {
    goBack() {
      this.$router.push('/consumers')
    },
    goToCashSales() {
      this.$router.push({
        name: 'Consumers.CashSales',
        params: { consumer: this.$route.params.consumer },
      })
    },
    goToCreditSales() {
      this.$router.push({
        name: 'Consumer.Loans',
        params: { consumer: this.$route.params.consumer },
      })
    },
    async fetchConsumer() {
      try {
        this.consumer.controller?.abort()
        this.consumer.controller = new AbortController()
        this.consumer.loading = true

        const axios = authAxios()
        const response = await axios.get(
          `/v2/consumers/${this.$route.params.consumer}`,
          {
            signal: this.consumer.controller.signal,
          },
        )

        this.consumer = {
          ...this.consumer,
          data: response.data,
        }
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching consumer:', e)
        }

        if (AxiosError(e)) {
          if (e.response?.status === 404) {
            ErrorPopup.fire('Error', 'Consumer not found')
            return
          }

          if (e.response?.status === 500) {
            ErrorPopup.fire(
              'Error',
              'Server error while fetching consumer details',
            )
            return
          }
        }
      } finally {
        this.consumer.loading = false
      }
    },
  },
}
</script>

<style scoped>
.sales-choice-card {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.sales-choice-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}
</style>
